<template>
  <div
    v-if="filteredPosts.length !== 0"
    class="swiper-cosa-usare"
    :class="{ 'swiper-cosa-usare--loading': loading }"
    :style="`background-image: url(${background})`">
    <div class="swiper-cosa-usare__title">
      <h3>{{ overlineTitle }}</h3>
    </div>

    <div
      v-swiper-cosa-usare="filteredPosts"
      class="swiper-container swiper-container--products">
      <div 
        v-lazy-container="{ selector: 'img' }"
        class="swiper-wrapper">
        <!-- Slides -->
        <router-link
          :to="{ name: 'single-post', params: { slug: slide.fields.slug } }"
          class="swiper-slide"
          v-for="(slide, index) of filteredPosts"
          :key="index">
            <img
              :data-src="slide.fields.image.fields.file.url"
              :data-loading="lazyLoading"
              :alt="slide.fields.image.fields.description"
              :width="slide.fields.image.fields.file.details.image.width"
              :height="slide.fields.image.fields.file.details.image.height"
            >
            <div class="swiper-cosa-usare__text-area">
              <div v-html="$_getDescriptionCarousel(slide.fields.swiperContent)"></div>
              <span>Continua</span>
            </div>
        </router-link>
        <!-- Fine Slides -->
      </div>
      <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { mapGetters, mapActions } from 'vuex'
import swiper from './swiper'

export default {
  name: 'SwiperCosaUsare',
  mixins: [swiper],
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/home-products-swiper.png'),
    background: require('@/assets/home/pennellata-come-usare-per.jpg')
  }),
  props: {
    overlineTitle: {
      type: String,
      required: false
    },
    shownPosts: {
      type: Number,
      default: () => 5
    },
    currentSlug: {
      type: String,
      default: undefined
    },
    category: {
      type: String,
      default: 'All'
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'blogPosts'
    ]),
    postsByCategory: {
      get () {
        if (this.category === 'All') {
          return this.blogPosts.slice(0, this.shownPosts - 1)
        }
        return this.blogPosts
          .filter((post) => post.fields.category.fields.title === this.category)
          .slice(0, this.shownPosts - 1)
      }
    },
    filteredPosts: {
      get () {
        if (this.currentSlug === undefined) return this.postsByCategory
        return this.postsByCategory.filter(post => post.fields.slug !== this.currentSlug)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadBlogPosts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadBlogPosts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_getDescriptionCarousel (content) {
      if (content === undefined) return ''
      return documentToHtmlString(content)
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
